<script>
	import { createEventDispatcher } from 'svelte'

	import VirtualList from '../../../components/VirtualList/VirtualList.svelte'
	import ThinButton from '../../../components/ThinButton/ThinButton.svelte'
	import LogDayItem from './LogDayItem.svelte'
	import LogItem from './LogItem.svelte'

	import moment from 'moment'
	// import userStore from '../../stores/user'
	import { vHeight as viewportHeight } from '../../../stores/bounds'

	export let items = []
	export let start
	export let end

	const dispatch = createEventDispatcher()

	const loadMoreBefore = (event) => {
		dispatch('load-before', {
			start: start,
			end: end
		})
	}
</script>

<div class="logs-holder">
	<VirtualList {items} height="{$viewportHeight}px" let:item>
		{#if item._type === 'program-item'}
			<LogItem data={item} on:update on:cancel on:log-time-create on:log-time-update on:delete />
		{:else if item._type === 'day-item'}
			<LogDayItem text={item.text} />
		{/if}

		{#if items.indexOf(item) === items.length - 1}
			<div class="load-before-holder">
				<ThinButton label="Elementi prima di {moment(start).format('DD MMM YYYY')}" on:click={loadMoreBefore}>
					<i class="far fa-arrow-down icn"></i> Elementi prima di {moment(start).format('DD MMM YYYY')}
				</ThinButton>
			</div>
		{/if}
	</VirtualList>
</div>

<style>
	.logs-holder {
		position: relative;
	}
	.logs-holder:before {
		content: '';
		position: absolute;
		top: 10px;
		left: 42px;
		height: 100%;
		width: 1px;
		background: #ecf2f6;
		z-index: -1;
	}
	.load-before-holder {
		padding: 0 0 20px 29px;
	}
	.logs-holder :global(.no-results-item) {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-weight: 600;
	}
</style>
